<template>
    <process-directory
        :type="1"
        title="Recuperações judiciais"
        route-base="/recuperacao-judicial"
    />
</template>
<script>
import ProcessDirectory from '@/components/ProcessDirectory.vue';
export default { name: 'JudicialRecoveryPage', components: { ProcessDirectory } };
</script>
